<div id="waitSpinner" [ngClass]="{overlay: is_loading}"></div>